define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LE = require("app");

    var ContentSystemGridViewModel;

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemGridViewModel = BaseModel.extend({
            name: "ContentSystemGridViewModel",
            defaults: {
                filters: {
                    "statusMultiple": [],
                    "skills": []
                },
                comparators: {
                    "name": "name",
                    "statusMultiple": "statusMultiple"
                }
            },

            pluck: function (_model) {
                return true;
            },

            setFilterValue: function(filterName, filterValue){
                if(!_.isUndefined(this.get("filters." + filterName))){
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function(filterName){
                return this.get("filters." + filterName);
            },

            predicate: function (model) {
                var modelIsInSelection = true;
                var passFilter;

                //check if model status is in selection:
                if(!_.isEmpty(this.get("filters.statusMultiple"))){
                    passFilter = false;
                    _.find(this.get("filters.statusMultiple"), function (status) {
                        if (model.getStatusState() === status) {
                            passFilter = true;
                            return true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                if(!_.isEmpty(this.get("filters.skills"))) {
                    passFilter = false;
                    var skillsArray = [];
                    _.each(model.getSkills(), function(skill) {
                        skillsArray.push(skill.skillId);
                    }, this);
                    _.find(this.get("filters.skills"), function(skills){
                        if (_.indexOf(skillsArray, skills) !== -1) {
                            passFilter = true;
                            return true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                return modelIsInSelection;

            }
        });
    });

    return ContentSystemGridViewModel;
});
